// extracted by mini-css-extract-plugin
export default {"SocialLoginBtn":"GoogleSocialLogin_SocialLoginBtn__13N2Z"};